<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <MenuCard :menuItems="menuItems" />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import MenuCard from "@/components/MenuCard";

export default {
    page: {
        title: i18n.t("module.system"),
    },
    components: { Layout, PageHeader, MenuCard },
    data() {
        return {
            title: i18n.t("module.system"),
            items: [
                {
                    text: i18n.t("module.system"),
                    active: true,
                },
            ],
            menuItems: [
                {
                    route: 'Configuration',
                    label: i18n.t('module.configuration'),
                    icon: 'mdi-cog-outline',
                    color: 'info',
                    core: true,
                },
                {
                    route: 'Diagnostic',
                    label: i18n.t('module.diagnostics'),
                    icon: 'mdi-console',
                    color: 'primary',
                    core: true,
                },
            ],
        };
    },
}
</script>